import React from 'react';
import AndroidInstallPrompt from './PWAPrompt'; // Component gốc của bạn
import IosInstallPrompt from './IosInstallPrompt'; // Component mới cho iOS

const PwaInstallPromptLoader = () => {
    // Hàm kiểm tra có phải là iOS không
    const isIos = () => /iPhone|iPad|iPod/.test(navigator.userAgent);

    // Nếu là iOS, hiển thị component hướng dẫn.
    // Ngược lại, hiển thị component với nút cài đặt chức năng cho Android.
    return isIos() ? <IosInstallPrompt /> : <AndroidInstallPrompt />;
};

export default PwaInstallPromptLoader;